import React, { useState } from 'react';
import { motion } from 'framer-motion';

const AdminLogin = ({ onLoginSuccess }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      if (response.ok) {
        // Store JWT token in localStorage
        if (data.token) {
          localStorage.setItem('adminToken', data.token);
        }
        onLoginSuccess(data);
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (error) {
      console.error('Admin login error:', error);
      setError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const containerVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <motion.div 
      className="admin-login"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="admin-login-content">
        <motion.div 
          className="admin-login-header"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <h1>🛡️ Admin Login</h1>
          <p>Access the admin dashboard</p>
        </motion.div>

        <motion.form 
          onSubmit={handleSubmit}
          className="admin-login-form"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="form-group">
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({
                ...credentials, 
                username: e.target.value
              })}
              placeholder="Admin Username"
              disabled={isLoading}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({
                ...credentials, 
                password: e.target.value
              })}
              placeholder="Admin Password"
              disabled={isLoading}
              required
            />
          </div>

          <motion.button 
            type="submit"
            className="admin-login-btn"
            disabled={isLoading}
            whileHover={{ scale: isLoading ? 1 : 1.05 }}
            whileTap={{ scale: isLoading ? 1 : 0.95 }}
          >
            {isLoading ? 'Logging in...' : '🚀 Login to Dashboard'}
          </motion.button>
        </motion.form>

        {error && (
          <motion.div 
            className="admin-error"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            ❌ {error}
          </motion.div>
        )}

        <motion.div 
          className="admin-footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <p>🏢 DIB Customer Feedback System</p>
          <small>Admin Dashboard Access</small>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AdminLogin;


